import React, { FC, useEffect, useState } from 'react'

import { twMerge } from 'tailwind-merge'

import {
  trans,
  ADD_TO_FAVORITE,
  REMOVE_FROM_FAVORITE,
} from '@helpers/translator'

// Définition des types pour les props du composant
interface FavoriteProps {
  isFavorite: boolean
  onClick: (isFavorite: boolean) => void
  className?: string
  inverted?: boolean
  displayLabel?: boolean
  iconSize?: string
}

const SvgIcon: React.FC<{
  isFavorite: boolean
  iconSize: string
  inverted: boolean
}> = ({ isFavorite, inverted, iconSize }) => {
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="transition-colors duration-300"
    >
      <path
        d="M19.4578 3.53571C18.9691 3.03631 18.3889 2.64014 17.7503 2.36986C17.1117 2.09957 16.4272 1.96045 15.7359 1.96045C15.0446 1.96045 14.3601 2.09957 13.7215 2.36986C13.0829 2.64014 12.5026 3.03631 12.0139 3.53571L10.9997 4.57166L9.98554 3.53571C8.99842 2.52742 7.6596 1.96097 6.26361 1.96097C4.86761 1.96097 3.52879 2.52742 2.54168 3.53571C1.55456 4.544 1 5.91153 1 7.33746C1 8.7634 1.55456 10.1309 2.54168 11.1392L10.9997 19.7787L19.4578 11.1392C19.9467 10.64 20.3346 10.0474 20.5992 9.39506C20.8638 8.74274 21 8.04356 21 7.33746C21 6.63137 20.8638 5.93219 20.5992 5.27987C20.3346 4.62755 19.9467 4.03488 19.4578 3.53571Z"
        fill={isFavorite ? '#EB0000' : 'black'}
        fillOpacity={isFavorite ? '1' : inverted ? '0' : '0.2'}
        stroke={
          isFavorite
            ? inverted
              ? 'red-500'
              : 'white'
            : inverted
              ? 'black'
              : 'white'
        }
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/**
 * Composant Favorite qui affiche un bouton avec une icône de cœur
 * @param {FavoriteProps} props - Les propriétés du composant
 * @returns {JSX.Element} Composant Favorite
 */
const Favorite: FC<FavoriteProps> = ({
  isFavorite,
  onClick,
  className = '',
  inverted = false,
  displayLabel = false,
  iconSize = '24',
}) => {
  return (
    <button
      type="button"
      onClick={() => onClick(!isFavorite)}
      className={twMerge(
        displayLabel ? 'flex items-center gap-x-2' : 'p-4',
        className,
      )}
      aria-label={
        isFavorite ? trans(REMOVE_FROM_FAVORITE) : trans(ADD_TO_FAVORITE)
      }
      aria-pressed={isFavorite}
    >
      {displayLabel && (
        <span>
          {isFavorite ? trans(REMOVE_FROM_FAVORITE) : trans(ADD_TO_FAVORITE)}
        </span>
      )}
      <SvgIcon
        isFavorite={isFavorite}
        iconSize={iconSize}
        inverted={inverted}
      />
    </button>
  )
}

export default Favorite
